export const formParams = (params) => params.replace(/ /g, '_').replace(/[/]/g, '-').toLowerCase()
export const resolveParams = (params) => params.replace(/[-]/g, '/').replace(/[_]/g, ' ')
